export default class Summary extends React.Component {
    render() {
        const {sref, model} = this.props
        if (model === undefined)
            return <React.Fragment/>

        return (
            <div className="configuration-editor-pricing-summary" ref={sref}>
                {model.discountedTotal.visible && <div className="configuration-editor-pricing-summary-item">
                    <span>{__('Total PPL')}</span>
                    <span>{model.discountedTotal.value}</span>
                </div>}

                {model.factoryTotal.visible && <div className="configuration-editor-pricing-summary-item">
                    <span>{__('Total factory cost')}</span>
                    <span>{model.factoryTotal.value}</span>
                </div>}

                {model.totalMargin.visible && <div className="configuration-editor-pricing-summary-item">
                    <span>{__('Total margin')}</span>
                    <span>{model.totalMargin.value}</span>
                </div>}
            </div>
        )
    }
}